import { submitTenderDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const submitTenderCallable = getCallable(submitTenderDefinition);
